"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _selectors = require("./selectors");

var _reselect = require("reselect");

var _RequestStatusTypes = _interopRequireDefault(require("settings-content-modals/EmailCreationModal/constants/RequestStatusTypes"));

var _default = function _default(requestType) {
  return (0, _reselect.createSelector)([_selectors.getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(requestType) || _RequestStatusTypes.default.UNINITIALIZED;
  });
};

exports.default = _default;
module.exports = exports.default;